export default __webpack_public_path__ + "e71acc5398cbcb93d7d56c3af2168d49.png";